import { render } from "./DownloadIcon.vue?vue&type=template&id=3b564040"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/DownloadIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b564040"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b564040', __exports__)) {
    api.reload('3b564040', __exports__)
  }
  
  module.hot.accept("./DownloadIcon.vue?vue&type=template&id=3b564040", () => {
    api.rerender('3b564040', render)
  })

}


export default __exports__